/* eslint-disable react/jsx-no-bind */
import * as React from "react";
import classNames from "classnames";
import { ErrorBoundary } from "app/lib/Bugsnag";
import { ErrorView } from "app/components/shared/ErrorView";
import { useNavigate } from "react-router-dom";

const Canvas = React.lazy(
  () => import(/* webpackChunkName: "canvas" */ "app/components/Playground/BuildCanvas"),
);

export default function CanvasPage() {
  const navigate = useNavigate();

  return (
    <ErrorBoundary
      FallbackComponent={() => <ErrorView className="px-4 py-2" clearError={() => navigate(0)} />}
    >
      <div className="relative min-w-0 flex-auto" data-testid="canvas">
        <div className="absolute flex h-full w-full overflow-y-auto">
          <div
            className={classNames(
              Features.BuildSidebar ? "" : "border border-gray-300",
              "relative flex-1 overflow-hidden rounded-md bg-white contain-layout data-[fullscreen=true]:fixed data-[fullscreen=true]:left-0 data-[fullscreen=true]:top-0 data-[fullscreen=true]:m-0 data-[fullscreen=true]:h-screen data-[fullscreen=true]:w-screen data-[fullscreen=true]:rounded-none data-[fullscreen=true]:border-none",
            )}
            id="canvas"
          >
            <div className="absolute h-full w-full">
              <React.Suspense fallback={null}>
                <Canvas />
              </React.Suspense>
            </div>
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
}
